import { ErrorType } from "src/types";
import * as Sentry from "@sentry/react";
import { CustomErrorCodes } from "src/constants/server-error-codes";

export const formatToastErrors = (
  error: any,
  customError?: { type: ErrorType; message: string }
) => {
  let errorType: ErrorType = "other";
  if (error.code === "ERR_CANCELED") {
    return;
  } else if (error.response) {
    if (
      error.response.status === 401 &&
      customError &&
      customError.type === "login"
    ) {
      errorType = "login";
    } else if (error.response.status === 401) {
      return CustomErrorCodes[401].message;
    } else if (
      error.response.status === 400 &&
      (error as any)?.response?.data?.non_field_errors?.includes(
        "signature_expired"
      )
    ) {
      return CustomErrorCodes[401].message;
    } else if (
      error.response.status === 400 &&
      (error as any)?.response?.data?.answers?.length > 0
    ) {
      return (
        (error as any)?.response?.data?.answers.toString() ??
        CustomErrorCodes[400].message
      );
    } else if (error.response?.data?.email) {
      errorType = "email-exists";
    } else if (error.response?.data?.postal_code) {
      errorType = "postal_code-invalid";
    }
  } else {
    return constructErrorMessage(99999, errorType);
  }

  return constructErrorMessage(error.response.status, errorType);
};

const constructErrorMessage = (status: number, type?: ErrorType) => {
  if (type === "login") {
    return `${CustomErrorCodes.loginFailed.message}`;
  } else if (type === "email-exists") {
    return `${CustomErrorCodes.emailExist.message}`;
  } else if (type === "postal_code-invalid") {
    return `${CustomErrorCodes.invalidPostalCode.message}`;
  } else {
    const val = Object.keys(CustomErrorCodes).includes(status.toString());
    if (val) {
      // Sentry.captureException(
      //   new Error(
      //     `${
      //       CustomErrorCodes[status as unknown as keyof typeof CustomErrorCodes]
      //         .message
      //     }`
      //   )
      // );
      return `${
        CustomErrorCodes[status as unknown as keyof typeof CustomErrorCodes]
          .message
      }`;
    } else {
      // Sentry.captureException(new Error(`${CustomErrorCodes.unknown.message}`));
      return `${CustomErrorCodes.unknown.message}`;
    }
  }
};
